module.exports = __webpack_public_path__ + "static/media/2_tata.640c1b11.svg";